<div
  class="status-badge"
  [class]="'status-badge--' + status().toLowerCase()"
  [class.status-badge--contract]="appearance() === 'contract'"
>
  {{ label() }}
</div>
